/**
 *
 * Asynchronously loads the component for UserSetup
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const UserSetup = lazyLoad(
  () => import('./index'),
  module => module.UserSetup,
);
